import * as React from "react";

import primaryColour from "../constants";

function SvgCamera(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={25} height={15} viewBox="0 0 25 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.7381 0.0957031H1.84524C0.833333 0.0957031 0 0.929037 0 1.94094V12.7505C0 13.7624 0.833333 14.5957 1.84524 14.5957H17.7381C18.75 14.5957 19.5833 13.7624 19.5833 12.7505V1.94094C19.5833 0.929037 18.75 0.0957031 17.7381 0.0957031ZM12.619 7.52427L8.09524 10.1433C7.97619 10.2028 7.79762 10.1433 7.79762 9.96475V4.72666C7.79762 4.60761 7.97619 4.48856 8.09524 4.54808L12.619 7.16713C12.7381 7.28618 12.7381 7.40523 12.619 7.52427Z"
        fill={fill}
      />
      <path
        d="M22.7381 2.40506L20.4762 3.83363C20.1786 4.0122 20.0595 4.30982 20.0595 4.66696V10.0241C20.0595 10.3812 20.2381 10.6789 20.4762 10.8574L22.7381 12.286C23.3333 12.6431 24.0476 12.167 24.0476 11.4527V3.23839C24.1071 2.46458 23.3333 2.04791 22.7381 2.40506Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgCamera;
